import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import moment from 'moment';
import { UAParser } from 'ua-parser-js';
import { LifecycleHelpModalComponent } from '../lifecycle-help-modal/lifecycle-help-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReferencesService } from 'src/app/services/references/references.service';
import { ConstantsService } from '../../../../services/constants/constants.service';
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import { SubscriptionLike } from 'rxjs';



@Component({
  selector: 'app-lifecycle',
  templateUrl: './lifecycle.component.pug',
  styleUrls: ['./lifecycle.component.scss'],
  standalone: false
})
export class LifecycleComponent implements OnInit, OnDestroy {
  checkId: any;
  lifecycleData: Array<any> = [];
  isOpen = false;
  lifecycleHelpModal: BsModalRef = new BsModalRef();
  loading = true;
  unsualActivityUserMap = {};
  unusualActivityExists = false;
  matchingIps: any;
  matchingBrowsers: any;
  count = 0;
  refereeIndex={};

  private locationSubscription: SubscriptionLike | null = null;

  constructor(
    private router: Router,
    private location: Location,
    private modalService: BsModalService,
    private referenceService: ReferencesService,
    private permissions: PermissionsService,
  ) {
    this.checkId = this.router?.getCurrentNavigation()?.extras?.state?.check?.id;
  }

  ngOnInit(): void {
    this.checkId = localStorage.getItem('check_id');
    this.permissions.setNavCheck(false);

    this.browserBackButtonClickEvent();

    this.referenceService.getCheckLifecycle(this.checkId).subscribe((lifecycleData) => {
      this.lifecycleData = lifecycleData['data']['lifecycle'];
      this.lifecycleData = this.lifecycleData.filter(check => !(check.action == "submitted" && check.action_arg1 == "")) //filter data with action="submitted" and action_arg1=""
      this.lifecycleData = this.convertData(this.lifecycleData);

      //unusual activity checks
      this.getUnusualActivityUserMap();
      this.unusualActivityExists = this.checkUnusualActivityExists();
      this.matchingIps = this.unusualActivityExists ? this.getMatchingIps() : [];
      this.matchingBrowsers = this.unusualActivityExists ? this.getMatchingBrowsers() : [];
      if (this.unusualActivityExists) {
        this.lifecycleData.forEach(lifecycle => {
          if ((lifecycle.user_type === ConstantsService.USERTYPE_CANDIDATE || (lifecycle.user_type === ConstantsService.USERTYPE_REFEREE && this.unsualActivityUserMap[lifecycle.user_id])) && (this.matchingBrowsers.indexOf(lifecycle.browser) > -1 || this.matchingIps.indexOf(lifecycle.ip_address) > -1)) {
            lifecycle["expanded"] = true;
          }
        })
      }

      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    if (this.locationSubscription) {
      this.locationSubscription.unsubscribe();
      this.locationSubscription = null;
    }
  }

  browserBackButtonClickEvent() {
    this.locationSubscription = this.location.subscribe((event) => {
      if (event.type === 'popstate') {
        this.goBack();
      }
    });
  }

  convertData(lifecycleDataArray) {
    lifecycleDataArray.forEach((lifecycle) => {
      lifecycle["action_date"] = moment(lifecycle["action_date"]).format('ll') + ', ' + moment(lifecycle["action_date"]).format('LT')
      lifecycle["user_type"] = lifecycle["user_type"][0].toUpperCase() + lifecycle["user_type"].slice(1);
      lifecycle["expanded"] = false;
      lifecycle["color"] = this.displayBackgroundColor(lifecycle["user_type"], lifecycle["user_id"]);
      if (lifecycle["action"] == "accessed shared reference") {
        lifecycle["user_type"] = lifecycle["user_type"] === ConstantsService.USERTYPE_EXTERNAL ? "Recipient" : "External"
        lifecycle["user_name"] = lifecycle["action_arg3"];
        lifecycle["action"] = "Accessed shared reference";
      }
      this.formatUserAgents(lifecycle);
    })
    return lifecycleDataArray;
  }

  getUnusualActivityUserMap() {
    this.lifecycleData.forEach((lifecycle) => {
      if (lifecycle.action == 'unusual activity detected') {
        this.unsualActivityUserMap[lifecycle.user_id] = true;
      }
    });
  }

  checkUnusualActivityExists() {
    return this.lifecycleData.find((lifecycle) => {
      return lifecycle.action == 'unusual activity detected';
    });
  }

  getMatchingIps() {
    const candidateIps = this.lifecycleData.filter((lifecycle) =>
      lifecycle.user_type == ConstantsService.USERTYPE_CANDIDATE
    ).map((lifecycle) => lifecycle.ip_address);

    // Only get Referee IPs that has been flagged as UA
    const refereeIps = this.lifecycleData.filter((lifecycle) =>
      lifecycle.user_type == ConstantsService.USERTYPE_REFEREE && this.unsualActivityUserMap[lifecycle.user_id]
    ).map((lifecycle) => lifecycle.ip_address);
    return refereeIps.filter(ip => candidateIps.includes(ip));

  }

  getMatchingBrowsers() {
    const candidateBrowsers = this.lifecycleData.filter((lifecycle) =>
      lifecycle.user_type == ConstantsService.USERTYPE_CANDIDATE
    ).map((lifecycle) => lifecycle.browser);

    // Only get Referee IPs that has been flagged as UA
    const refereeBrowsers = this.lifecycleData.filter((lifecycle) =>
      lifecycle.user_type == ConstantsService.USERTYPE_REFEREE && this.unsualActivityUserMap[lifecycle.user_id]
    ).map((lifecycle) => lifecycle.browser);

    return refereeBrowsers.filter(item => candidateBrowsers.includes(item));
  }

  formatUserAgents(checkData) {
    const result = new UAParser(checkData.browser);

    const os = result.getOS();
    const browser = result.getBrowser();
    checkData["userAgent"] = '';
    if (os.name) checkData["userAgent"] += `${os.name}/`;
    if (browser.name) checkData["userAgent"] += `${browser.name}`;
    if (browser.version) checkData["userAgent"] += ` ${browser.version}`;
  }


  displayDropDown(index) {
    return this.lifecycleData[index]["expanded"] = !this.lifecycleData[index]["expanded"];
  }

  openLifecycleHelpModal() {
    this.lifecycleHelpModal = this.modalService.show(LifecycleHelpModalComponent, {
      class: 'modal-dialog-centered help-modal'
    });
  }

  expandAll() {
    this.isOpen = true;
    this.lifecycleData.forEach(check => { check["expanded"] = true });
  }
  collapseAll() {
    this.isOpen = false;
    this.lifecycleData.forEach(check => { check["expanded"] = false });
  }

  displayBackgroundColor(userType, user_id) {
    if (userType == ConstantsService.USERTYPE_CANDIDATE) {
      return 'rgba(209, 132, 0, 0.1)';
    } else if (userType == ConstantsService.USERTYPE_EMPLOYER) {
      return 'rgba(50, 115, 95, 0.1)';
    } else if (userType == ConstantsService.USERTYPE_REFEREE) {

        if(this.refereeIndex[user_id]) {
          return this.refereeIndex[user_id];
        }
        else {
          const color = this.getRandomColor();
          this.refereeIndex[user_id] = color;
          return color;
        }
    }
    return '#FFFFFF';
  }

  displayTextColor(userType) {
    if (userType === ConstantsService.USERTYPE_EXTERNAL) {
    return '#AF0000'
  }
    return '#000000'
  }


  getRandomColor() {
    this.count += 1;
    const colors = ConstantsService.LIFECYCLE_COLORS;
    const random = this.count % 8; //get a random color
    return colors[random];
  }

  getTimeDiff(fromDate, toDate) {
    const date_diff = moment.duration(moment(fromDate).diff(moment(toDate)));

    let timePeriod = '';
    if (date_diff.years() > 0) {
      timePeriod += date_diff.years() + 'y ';
    }
    if (date_diff.days() > 0) {
      timePeriod += date_diff.days() + 'd ';
    }
    if (date_diff.hours() > 0) {
      timePeriod += date_diff.hours() + 'h ';
    }
    if (date_diff.minutes() > 0) {
      timePeriod += date_diff.minutes() + 'm ';
    }
    if (date_diff.seconds() >= 0) {
      timePeriod += date_diff.seconds() + 's ';
    }
    return timePeriod;
  }


  goBack() {
    this.refereeIndex={};
    localStorage.removeItem('check_id');
    this.permissions.setNavCheck(true);
    this.router.navigateByUrl('requests', { state: { 'from': 'lifeCyclePage', 'checkId': this.checkId } });
  }

  render_user_type(lifecycledata)
  {
    if(lifecycledata.user_type)
    {
      switch(lifecycledata.user_type) {
        case 'Referee':
          return $localize`Referee`;
        case 'Candidate':
          return $localize`Candidate`;
        case 'Employer':
          return $localize`Employer`;
        case 'System':
          return $localize`System`;
        case 'External':
          return $localize`External`;
        case 'Admin':
          return $localize`Admin`;
        default:
          return $localize`${lifecycledata.user_type}`;
      }
    }
    else {return ' - '}
  }

}
